import { createFileRoute } from '@tanstack/react-router'
import type { VideosPageSearch } from '@/routes/$orgSlug/$clientSlug/videos'

const TABS = ['overview', 'videos', 'live'] as const

export const Route = createFileRoute('/portal/videos')({
  validateSearch: (search: Record<string, unknown>): VideosPageSearch => ({
    tab: (TABS as readonly unknown[]).includes(search.tab) ? (search.tab as VideosPageSearch['tab']) : undefined,
  }),
})
